import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useLocalizedPath } from '@/hooks/useLocalizedPath';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryLotNumber,
    getItemSummaryTitle,
    getItemSummaryUrl,
} from '@/redux/modules/item/summary/itemSummary.selectors';

type Props = {
    hideLotNumbers?: boolean;
    itemId: number;
    onClick?: (itemUrl?: string) => void;
    openOnBlank?: boolean;
};

const TitleRowComponent = ({ hideLotNumbers, itemId, onClick, openOnBlank }: Props) => {
    const navigate = useNavigate();

    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const lotNumber = useAppSelector((state) => getItemSummaryLotNumber(state, itemId));
    const itemUrl = useAppSelector((state) => getItemSummaryUrl(state, itemId));
    const itemHref = useLocalizedPath(itemUrl);

    const lotNumberDisplay = lotNumber ? <span>{lotNumber}:&nbsp; </span> : <span>&nbsp; 0000</span>;

    const titleContent = (
        <>
            {!hideLotNumbers && lotNumberDisplay}
            {title}
        </>
    );

    return (
        <div className="relative mb-3xs block min-h-[48px] overflow-visible text-text-primary mobile:min-h-[40px]">
            {title ? (
                <H4
                    as="span"
                    className="static inline-block font-secondary tracking-[0.5px] break-words whitespace-normal capitalize mobile:text-[13px] mobile:leading-[18px] [&_span:first-of-type]:font-secondary"
                >
                    {openOnBlank ? (
                        <Link
                            className="line-clamp-2"
                            data-testid="itemTitleText"
                            href={itemHref}
                            onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                onClick?.(itemUrl);
                                navigate(itemUrl);
                            }}
                            target="_blank"
                        >
                            {titleContent}
                        </Link>
                    ) : (
                        <RouteLink
                            className="line-clamp-2"
                            data-testid="itemTitleText"
                            onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                onClick?.(itemUrl);
                                navigate(itemUrl);
                            }}
                            to={itemUrl}
                        >
                            {titleContent}
                        </RouteLink>
                    )}
                </H4>
            ) : (
                <H4
                    as="span"
                    className="static inline-block font-secondary tracking-[0.5px] break-words whitespace-normal capitalize mobile:text-[13px] mobile:leading-[18px] [&_span:first-of-type]:font-secondary"
                >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                </H4>
            )}
        </div>
    );
};

export const TitleRow = memo<Props>(TitleRowComponent);
